import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Banner from "../components/Banner/Banner";
import Stats from "../components/Stats";
import FeaturedHomes from "../components/FeaturedHomes";
import OngoingProjects from "../components/OngoingProjects";
import OfficeStore from "../components/OfficeStore";
import Header from "../../layouts/Header/Header";
import Footer from "../../layouts/Footer/Footer";
import ResidenceSlider from "../components/ResidenceSlider";
import VillaSlider from "../components/VillaSlider";

const animationVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const AnimatedSection = ({ children }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={animationVariants}
      transition={{ duration: 0.8 }}
    >
      {children}
    </motion.div>
  );
};

const Home = () => {
  return (
    <div>
      <Header />
      <AnimatedSection>
        <Banner />
      </AnimatedSection>
      <AnimatedSection>
        <Stats />
      </AnimatedSection>
      <AnimatedSection>
        <FeaturedHomes />
      </AnimatedSection>
      <AnimatedSection>
        <ResidenceSlider />
      </AnimatedSection>
      <AnimatedSection>
        <OfficeStore />
      </AnimatedSection>
      <AnimatedSection>
        <VillaSlider />
      </AnimatedSection>
      <AnimatedSection>
        <OngoingProjects />
      </AnimatedSection>
      <Footer />
    </div>
  );
};

export default Home;
